import type { UserResources } from "~types/user";
import type { UserPermission } from "~types/userPermission";
import { PermissionScopeTypes } from "../enums/permissionScopeTypes";
import type { UserPermissionTransformed } from "../types";

const transformPermission = (
  permission: UserPermission,
  resources: UserResources,
  isGroupPermission: boolean,
): UserPermissionTransformed => {
  const scopeObjects =
    permission.scope === PermissionScopeTypes.EntityGroup ? resources.entityGroups : resources[permission.scope?.toLowerCase() || ""];

  const scopeValues =
    permission.scopeIds?.map((id) => ({
      value: id,
      label: scopeObjects?.[id]?.nameLocal || scopeObjects?.[id]?.nameFullLocal || id,
    })) || null;

  const getScopeTypeValues = (scopeType: PermissionScopeTypes) => (scopeType === permission.scope ? scopeValues : null);

  return {
    ...permission,
    scopeValues,
    isGroupPermission,
    leagues: getScopeTypeValues(PermissionScopeTypes.League),
    competitions: getScopeTypeValues(PermissionScopeTypes.Competition),
    seasons: getScopeTypeValues(PermissionScopeTypes.Season),
    entities: getScopeTypeValues(PermissionScopeTypes.Entity),
    entityGroups: getScopeTypeValues(PermissionScopeTypes.EntityGroup),
  };
};

export default transformPermission;
